import { render, staticRenderFns } from "./AddTeamPlan.vue?vue&type=template&id=b55a4d66&scoped=true"
import script from "./AddTeamPlan.vue?vue&type=script&lang=js"
export * from "./AddTeamPlan.vue?vue&type=script&lang=js"
import style0 from "./AddTeamPlan.vue?vue&type=style&index=0&id=b55a4d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55a4d66",
  null
  
)

export default component.exports